// ------------------------------------------------------------------
// PURE MODULE: narrator.mod.js
// ------------------------------------------------------------------
import gsap from "gsap"; 

// --- MODULE SCOPED VARIABLES ---
// These replace the "Globals" from the IIFE. 
// They are shared across all calls to Narrator() within this file.
let audioPlayTimer = null; // Stores the ID of the setTimeout
let currentAudioListener = null; // Will store the active onTimeUpdate function

//export function Narrator(item, index, selector = '.txani') {
export function Narrator(item, index, textElement) {
  ///////////////////////// MODULE: Triggered Narrator Animation /////////////////////////

//    const textElement = item.image.querySelector(selector);
    if (!textElement) return;

    // 1. Extract audio attributes
    const audioStart = parseFloat(textElement.getAttribute('au-s')) || 0;
    const audioEnd = parseFloat(textElement.getAttribute('au-e')) || 0;

    // 2. Split text into spans (assuming global spltxt function)
    const [spans, count] = spltxt(textElement, "invis");

    // 3. Create the GSAP text animation
    const textAnimation = gsap.to(spans, { 
      paused: true, 
      duration: 1.4, 
      autoAlpha: 1, 
      stagger: { from: "left", amount: count * 0.25 }
    });

    // 4. Attach the text animation call to the slide's fade-in timeline
    // Note: item.animationState must be initialized before calling this
    if (item.animationState && item.animationState.fadeInTween) {
        item.animationState.fadeInTween.call(
          replayifani,
          [textAnimation, App.sound.nartrack, audioStart, audioEnd],
          0
        );
    }

    // 5. Play immediately for the first slide
    if (index === 0) {
      replayifani(textAnimation, App.sound.nartrack, audioStart, audioEnd);
    }
 }

///////////////////////////////////////////////////////////////////////
// --- HELPER FUNCTIONS ---
// Defined at module level so they are accessible to Narrator
///////////////////////////////////////////////////////////////////////

// ANIMATED TEXT
function spltxt(element, spanClass) { // CONSIDER MOVING TO UTILS!
  if (!element || !element.textContent) {
    return [[], 0];
  }

  const words = element.textContent.trim().split(/\s+/);
  const fragment = document.createDocumentFragment();

  const spans = words.map(word => {
    const span = document.createElement("span");
    span.className = spanClass;
    span.textContent = `${word} `;
    fragment.appendChild(span);
    return span;
  });

  // Clear the original element and append the new spans all at once
  element.textContent = "";
  element.appendChild(fragment);

  return [spans, spans.length];
}
// END ANIMATED TEXT

// AUDIO HELPERS
// Custom parallel tween + audio replay function avoiding conflicts
function replayifani(tween, audio, start, stop) {
  // If there's a "play" command pending from a previous slide, cancel it before we do anything else.
  if (audioPlayTimer) {
    clearTimeout(audioPlayTimer);
  }
  if (!tween) return;// Guard clause to exit early if there's no animation tween.
  
  tween.restart(); // 1. Restart the text animation
  if (App.sound.soundon && audio && start !== null && stop !== null && !isNaN(start) && !isNaN(stop)) {
    pausemed(audio);// 3. Pause first    
    // 4. Set the new timeout and STORE ITS ID
    audioPlayTimer = setTimeout(() => {
      playSegment(audio, start, stop);
      audioPlayTimer = null; // Clear the timer ID once it has run
//    }, 10);
    }, 300);
  }
}
// Custom audio pause/interruption function on slide toggle
function pausemed(med){
  if(!med.paused && App.sound.nartrack.isplayin){
    med.pause();
//    console.log(lastN,'INTERRUPTED');
    // Remove the active listener so it can't fire again.
    if (currentAudioListener) {
      med.removeEventListener('timeupdate', currentAudioListener);
      currentAudioListener = null;
    }
  }
}
// Custom function that plays audio file segments
function playSegment(audioObj, start, stop) {
  if (!audioObj || App.sound.nartrack.isplayin) { 
    return;
  }
  // Clean up in case pausemed() didn't catch it.
  if (currentAudioListener) {
    audioObj.removeEventListener('timeupdate', currentAudioListener);
  }
  // A named function is used so we can remove it later. Store it in the global variable.
  currentAudioListener = () => {
    if (audioObj.currentTime >= stop) {
      audioObj.pause();
//      console.log(lastN,'PAUSE');
      // Remove the event listener to prevent it from running forever.
      audioObj.removeEventListener('timeupdate', currentAudioListener);
      currentAudioListener = null; // Clear the stored listener
    }
  };
  audioObj.addEventListener('timeupdate', currentAudioListener);
  audioObj.currentTime = start;

  audioObj.play().catch(error => {
    // Clean up the listener if play fails.
    if (currentAudioListener) {
      audioObj.removeEventListener('timeupdate', currentAudioListener);
      currentAudioListener = null;
    }
  });
//  console.log(lastN,'PLAY');
}
// END AUDIO HELPERS